import React, { useEffect } from 'react';

import { useMutation } from '@tanstack/react-query';
import { AxiosError, HttpStatusCode } from 'axios';
import { FullScreenLoader } from 'components/FullScreenLoader';
import queryString from 'query-string';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthService } from 'services/auth-service';
import { NotificationService } from 'services/notification-service';
import { ROUTE_LINKS } from 'shared/constants/route-links';
import { navigatePostLogin } from 'shared/utils/navigation';

export function GoogleAuthHandlerPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { code, state } = queryString.parse(location.search);
  // Since we're using cognito, the state parameter is used to pass additional parameters to the callback URL
  const stateParams = state ? queryString.parse(String(state)) : {};

  const authWithGoogleMutation = useMutation({
    mutationFn: AuthService.authWithGoogle,
    onSuccess: () => navigatePostLogin(stateParams),
    onError: (error: AxiosError) => {
      const errorCode = error.response?.status;
      if (errorCode === HttpStatusCode.Conflict) {
        NotificationService.showResult(false, t('AUTH.ERROR.CONFLICT_EMAIL_USED_WITH_PASSWORD'));
      } else {
        NotificationService.showResult(false, t('AUTH.ERROR.SIGN_UP'));
      }
      navigate(ROUTE_LINKS.login);
    }
  });

  useEffect(() => {
    if (!code || typeof code !== 'string') {
      navigate(ROUTE_LINKS.login);
      return;
    }
    authWithGoogleMutation.mutate(code);
  }, []);

  return <FullScreenLoader />;
}
